import {Input as KendoInput} from "@progress/kendo-react-inputs";

import KendoHOC from "./utils/KendoHOC";

const Input = (options) => (KendoHOC(KendoInput, options));

export default Input;
